var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEveronLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 22,
    viewBox: "0 0 123 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_18917_202273)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.8008,
    y: 0.46875,
    width: 30.6427,
    height: 21.1264,
    rx: 10.5632,
    fill: "#A6E4FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.3363 11.0334C98.3363 14.5986 95.4462 17.4887 91.8811 17.4887C88.3159 17.4887 85.4258 14.5986 85.4258 11.0334C85.4258 7.46825 88.3159 4.57812 91.8811 4.57812C95.4462 4.57812 98.3363 7.46825 98.3363 11.0334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.445 11.0319C102.445 16.8658 97.7154 21.5951 91.8815 21.5951C86.0477 21.5951 81.3184 16.8658 81.3184 11.0319C81.3184 5.19805 86.0477 0.46875 91.8815 0.46875C97.7154 0.46875 102.445 5.19805 102.445 11.0319ZM91.8815 17.4872C95.4467 17.4872 98.3368 14.5971 98.3368 11.0319C98.3368 7.46678 95.4467 4.57665 91.8815 4.57665C88.3164 4.57665 85.4263 7.46678 85.4263 11.0319C85.4263 14.5971 88.3164 17.4872 91.8815 17.4872Z",
    fill: "#26B0EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8691 15.9363C53.4288 19.4377 48.548 20.3131 44.9363 17.914C41.2921 15.5149 40.3484 10.5545 42.7888 6.92342C45.3593 3.0978 50.24 2.02792 53.9494 4.45946C55.7715 5.65902 56.9429 7.50699 57.2683 9.5819L44.3506 9.54948C43.6999 9.54948 43.1793 10.0682 43.1793 10.7166C43.1793 11.365 43.6999 11.8838 44.3506 11.8838H59.8062V11.5271C59.9038 7.96087 58.1793 4.65398 55.1533 2.64391C50.2726 -0.59814 44.1229 0.66626 40.8365 5.56176C37.5827 10.4248 38.9168 16.6171 43.9602 19.9565C48.4504 22.9391 54.6652 21.7396 57.8214 17.298L58.0492 16.9738L56.0644 15.677L55.8691 15.9363Z",
    fill: "#26B0EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3878 11.5642C19.2896 15.804 15.6902 19.3965 11.3382 19.3965C6.95344 19.3965 3.38675 15.6422 3.38675 11.273C3.38675 6.64483 6.888 3.08472 11.3709 3.08472C13.5633 3.08472 15.592 3.99093 16.9991 5.51207L6.13539 12.5675C5.57912 12.9236 5.44823 13.6679 5.80817 14.1858C6.16811 14.736 6.92072 14.8654 7.44427 14.5094L20.4022 6.0299L20.2058 5.70625C18.308 2.69634 15.003 0.883927 11.3382 0.851562C5.48095 0.883927 0.998047 5.28551 0.998047 11.1759C0.998047 17.0015 5.5464 21.5649 11.6327 21.5973C17.0645 21.5973 21.6129 17.0339 21.7438 11.5966V11.2082H19.3551L19.3878 11.5642Z",
    fill: "#26B0EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1508 18.326C29.0163 15.4092 23.7326 1.24656 23.7326 1.24656H21.1719L28.1735 20.0112C28.53 20.8538 29.2107 21.4048 30.3128 21.4048C31.4474 21.4048 32.1281 20.8538 32.4522 20.0112L39.1621 2.1216C39.4862 1.34379 38.9028 0.46875 38.06 0.46875C37.5738 0.46875 37.1199 0.760429 36.9579 1.21415C35.7585 4.19575 31.5122 15.7981 30.5397 18.2935C30.4749 18.5204 30.2156 18.5204 30.1508 18.326Z",
    fill: "#26B0EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3586 3.83818V1.03906H62.0938V21.0235H64.3586V10.5105C64.3586 6.01889 67.206 3.25232 69.8268 3.25232H70.7004C71.3151 3.25232 71.8005 2.7641 71.8005 2.14569C71.8005 1.52728 71.3151 1.03906 70.7004 1.03906H69.665C67.4324 1.03906 65.4587 2.30843 64.3586 3.83818Z",
    fill: "#26B0EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.527 3.02201C118.869 1.34138 116.561 0.46875 113.862 0.46875C111.164 0.46875 108.856 1.34138 107.197 3.02201C105.604 4.638 104.727 6.93271 104.727 9.48597V21.0241H109.376V9.48597C109.376 6.90039 111.294 4.92888 113.862 4.92888C116.431 4.92888 118.349 6.90039 118.349 9.48597V21.0241H122.998V9.48597C122.998 6.93271 122.12 4.638 120.527 3.02201Z",
    fill: "#26B0EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18917_202273",
    x: 71.8008,
    y: 0.46875,
    width: 30.6426,
    height: 23.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301146 0 0 0 0 0.400217 0 0 0 0 0.491667 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18917_202273"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveronLogo);
export default __webpack_public_path__ + "static/media/everonLogo.b7391b76cd769eee8c7dd68c189b3107.svg";
export { ForwardRef as ReactComponent };